export const lightTheme = {
    dark: '#1a191f',
    light: '#F1F1F4',
    black: '#000000',
    white: '#FFFFFF',
    background: '#F1F1F4',
    fill: '#F1F1F4',
    primary: '#3333CC',
    secondary: '#696788',
    danger: '#DE505C',
    success: '#20AA80',
    warning: '#DEAA52',
    grey: '#AAAAB9',
    text: '#1a191f',
    secondaryText: '#727180',
    lightText: '#F1F1F4',
    border: '#D2D2DC',

}

export const darkTheme = {
  dark: '#F1F1F4',
  light: '#1a191f',
  black: '#FFFFFF',
  white: '#000000',
  background: '#1a191f',
  fill: '#1a191f',
  primary: '#3333CC',
  secondary: '#696788',
  danger: '#DE505C',
  success: '#20AA80',
  warning: '#DEAA52',
  grey: '#AAAAB9',
  text: '#F1F1F4',
  secondaryText: '#a2a1c0',
  lightText: '#1a191f',
  border: '#D2D2DC',

}
